<template>
    <div>
        <post v-for="post in postList.edges" :key="post.node.id" :id="post.node.id" :post="post.node"/>
    </div>
</template>

<script>
    import Post from "./Post";
    import {mapState} from "vuex";
    import {PostManager} from "../managers";

    export default {
        name: "PostList",
        components: { Post },
        props: ["posts"],
        computed: {
            ...mapState([
                'user'
            ]),
            postList: function () {
                return PostManager.setContext(this.posts, this.user);
            }
        }
    }
</script>

<style scoped>

</style>